import React, { useMemo } from "react";
import { numberWithoutComma } from "../../pages/balance/component/VIDrawerDebt.Main";

export const sumCapitalInvest = (addInvest, ReturnInsurance) => {
  let sumValue = 0;

  addInvest
    ?.sort((a, b) => new Date(b?.created) - new Date(a?.created))
    ?.map((row, index) => {
      /*---------- พันธบัตร/หุ้นกู้ ----------*/
      row?.options_property_invest === "property_invest_bond" &&
        row?.invest_bond_lists
          ?.sort((a, b) => new Date(b?.created) - new Date(a?.created))
          ?.map((row, indexCard) => {
            sumValue += Number(row?.amount || 0);
          });

      /*---------- หุ้นบุริมสิทธิ ----------*/
      row?.options_property_invest === "property_invest_preferred" &&
        row?.invest_preferred_lists
          ?.sort((a, b) => new Date(b?.created) - new Date(a?.created))
          ?.map((row, indexCard) => {
            sumValue += numberWithoutComma(row?.amount || 0);
          });

      /*---------- หุ้นสามัญ ----------*/
      row?.options_property_invest === "property_invest_normal" &&
        row?.invest_normal_lists
          ?.sort((a, b) => new Date(b?.created) - new Date(a?.created))
          ?.map((row, indexCard) => {
            sumValue += Number(row?.amount || 0);
          });

      /*---------- กองทุนรวมตลาดเงิน ----------*/
      row?.options_property_invest === "property_invest_market" &&
        row?.invest_market_lists
          ?.sort((a, b) => new Date(b?.created) - new Date(a?.created))
          ?.map((row, indexCard) => {
            sumValue += Number(row?.amount || 0);
          });

      /*---------- กองทุนรวมหุ้น ----------*/
      row?.options_property_invest === "property_all_invest" &&
        row?.all_invest_lists
          ?.sort((a, b) => new Date(b?.created) - new Date(a?.created))
          ?.map((row, indexCard) => {
            sumValue += Number(row?.amount || 0);
          });

      /*---------- กองทุนรวมเพื่อการเลี้ยงชีพ ----------*/
      row?.options_property_invest === "property_invest_life" &&
        row?.invest_life_lists
          ?.sort((a, b) => new Date(b?.created) - new Date(a?.created))
          ?.map((row, indexCard) => {
            sumValue += Number(row?.amount || 0);
          });

      /*---------- กองทุนรวมผสม ----------*/
      row?.options_property_invest === "property_invest_mixed" &&
        row?.invest_mixed_lists
          ?.sort((a, b) => new Date(b?.created) - new Date(a?.created))
          ?.map((row, indexCard) => {
            sumValue += Number(row?.amount || 0);
          });

      /*---------- กองทุนสำรองเลี้ยงชีพ ----------*/
      row?.options_property_invest === "property_invest_provident_fund" &&
        row?.invest_provident_fund_lists
          ?.sort((a, b) => new Date(b?.created) - new Date(a?.created))
          ?.map((row, indexCard) => {
            sumValue += Number(row?.amount || 0);
          });

      /*---------- เงินออมเพื่อวัยเกษียณอื่น ๆ ----------*/
      row?.options_property_invest ===
        "property_invest_other_retirement_savings" &&
        row?.invest_other_retirement_savings_lists
          ?.sort((a, b) => new Date(b?.created) - new Date(a?.created))
          ?.map((row, indexCard) => {
            sumValue += Number(row?.amount || 0);
          });

      /*---------- ตลาดเงินอื่น ๆ ----------*/
      row?.options_property_invest === "property_money_market_other" &&
        row?.invest_money_market_other_lists
          ?.sort((a, b) => new Date(b?.created) - new Date(a?.created))
          ?.map((row, indexCard) => {
            sumValue += Number(row?.amount || 0);
          });

      /*---------- ตราสารอนุพันธ์ ----------*/
      row?.options_property_invest ===
        "property_invest_derivative_instruments" &&
        row?.invest_derivative_instruments_lists
          ?.sort((a, b) => new Date(b?.created) - new Date(a?.created))
          ?.map((row, indexCard) => {
            sumValue += Number(row?.amount || 0);
          });

      /*---------- มูลค่าเงินสดในกรมธรรม์ประกันชีวิต ----------*/
      row?.options_property_invest ===
        "property_invest_life_insurance_policy" &&
        row?.invest_life_insurance_policy_lists
          ?.sort((a, b) => new Date(b?.created) - new Date(a?.created))
          ?.map((row, indexCard) => {
            sumValue += Number(row?.amount || 0);
          });

      /*---------- สลากออมสิน ----------*/
      row?.options_property_invest === "property_aomsin_bond_policy" &&
        row?.aomsin_bond_policy_lists
          ?.sort((a, b) => new Date(b?.created) - new Date(a?.created))
          ?.map((row, indexCard) => {
            sumValue += Number(row?.amount || 0);
          });

      /*---------- ตราสารหนี้อื่นๆ ----------*/
      row?.options_property_invest === "property_debt_instruments" &&
        row?.property_debt_instruments_lists
          ?.sort((a, b) => new Date(b?.created) - new Date(a?.created))
          ?.map((row, indexCard) => {
            sumValue += Number(row?.amount || 0);
          });

      /*---------- อสังหาริมทรัพย์ ----------*/
      row?.options_property_invest === "property_invest_real_estate" &&
        row?.invest_real_estate_lists
          ?.sort((a, b) => new Date(b?.created) - new Date(a?.created))
          ?.map((row, indexCard) => {
            sumValue += Number(row?.amount || 0);
          });

      /*---------- มูลค่าทองคำ ----------*/
      row?.options_property_invest === "property_invest_gold_cost" &&
        row?.invest_gold_cost_lists
          ?.sort((a, b) => new Date(b?.created) - new Date(a?.created))
          ?.map((row, indexCard) => {
            sumValue += Number(row?.amount || 0);
          });

      /*---------- หุ้นในส่วนที่เป็นเจ้าของ ----------*/
      row?.options_property_invest === "property_invest_owner" &&
        row?.invest_owner_lists
          ?.sort((a, b) => new Date(b?.created) - new Date(a?.created))
          ?.map((row, indexCard) => {
            sumValue += Number(row?.amount || 0);
          });

      /*---------- ตราสารทุนอื่นๆ ----------*/
      row?.options_property_invest === "property_equity_instruments" &&
        row?.invest_equity_instruments_lists
          ?.sort((a, b) => new Date(b?.created) - new Date(a?.created))
          ?.map((row, indexCard) => {
            sumValue += Number(row?.amount || 0);
          });

      /*---------- เงินลงทุนอื่น ๆ ----------*/
      row?.options_property_invest === "property_invest_other" &&
        row?.invest_other_lists
          ?.sort((a, b) => new Date(b?.created) - new Date(a?.created))
          ?.map((row, indexCard) => {
            sumValue += Number(row?.amount || 0);
          });

      /*---------- ตราสารหนี้ภาครัฐ ----------*/
      row?.options_property_invest === "property_invest_goverment" && (
        <div key={index}>
          {row?.invest_goverment_lists
            ?.sort((a, b) => new Date(b?.created) - new Date(a?.created))
            ?.map((row, indexCard) => {
              sumValue += Number(row?.amount || 0);
            })}
        </div>
      );

      /*---------- ตราสารหนี้ภาคเอกชน ----------*/
      row?.options_property_invest === "property_invest_private" &&
        row?.invest_private_lists
          ?.sort((a, b) => new Date(b?.created) - new Date(a?.created))
          ?.map((row, indexCard) => {
            sumValue += Number(row?.amount || 0);
          });

      /*---------- เงินฝาก ----------*/
      row?.options_property_invest === "property_invest_deposit" &&
        row?.invest_deposit_lists
          ?.sort((a, b) => new Date(b?.created) - new Date(a?.created))
          ?.map((row, indexCard) => {
            sumValue += Number(row?.amount || 0);
          });

      ReturnInsurance?.map((row, indexCard) => {
        sumValue += Number(row?.amount || 0);
      });
    });

  return sumValue;
};

export const sumAssetAll = (addAsset) => {
  // console.log("addAsset", addAsset);

  let sumAssetAll = 0;
  addAsset?.map((row, index) => {
    /*---------- เงินสด ----------*/
    if (row?.options_property_asset === "property_cash") {
      row?.property_cash_lists?.map((row, indexCard) => {
        sumAssetAll += Number(row?.amount || 0);
      });
    }

    /*---------- บัญชีเงินฝากออมทรัพย์ ----------*/
    if (row?.options_property_asset === "property_saving") {
      row?.property_saving_lists?.map((row, indexCard) => {
        sumAssetAll += Number(row?.amount || 0);
      });
    }

    /*---------- บัญชีเงินฝากประจำ ----------*/
    if (row?.options_property_asset === "property_deposit") {
      row?.property_deposit_lists?.map((row, indexCard) => {
        sumAssetAll += Number(row?.amount || 0);
      });
    }

    /*---------- เงินฝากสหกรณ์ออมทรัพย์ ----------*/
    if (row?.options_property_asset === "property_saving_cooperative") {
      row?.property_saving_cooperative_lists?.map((row, indexCard) => {
        sumAssetAll += Number(row?.amount || 0);
      });
    }

    /*---------- กองทุนตราสารหนี้สินระยะสั้น ----------*/
    if (row?.options_property_asset === "property_fund_debt") {
      row?.property_fund_debt_lists?.map((row, indexCard) => {
        sumAssetAll += Number(row?.amount || 0);
      });
    }
  });
  return sumAssetAll;
};

export const sumPersonalAsset = (addPrivate) => {
  let sumPrivate = 0;

  addPrivate?.map((row, index) => {
    /*---------- เครื่องประดับ ----------*/
    row?.options_property_private === "property_accessories" &&
      row?.accessories_lists?.map((row, indexCard) => {
        sumPrivate += Number(row?.amount || 0);
      });

    /*---------- รถยนต์ ----------*/
    row?.options_property_private === "property_car" &&
      row?.car_lists?.map((row, indexCard) => {
        sumPrivate += Number(row?.amount || 0);
      });

    /*---------- ที่อยู่อาศัย ----------*/
    row?.options_property_private === "property_home" &&
      row?.home_lists?.map((row, indexCard) => {
        sumPrivate += Number(row?.amount || 0);
      });

    /*---------- ของสะสมมีราคา ----------*/
    row?.options_property_private === "property_collection" &&
      row?.collection_lists?.map((row, indexCard) => {
        sumPrivate += Number(row?.amount || 0);
      });

    /*---------- อื่น ๆ ----------*/
    row?.options_property_private === "property_other" &&
      row?.other_lists?.map((row, indexCard) => {
        sumPrivate += Number(row?.amount || 0);
      });
  });
  return sumPrivate;
};

export const sumLiabilities = (addIntangible) => {
  let sumLiabilities = 0;

  addIntangible?.map((row, index) => {
    /*---------- ลิขสิทธิ ----------*/
    row?.options_property_intangible === "property_copyright" &&
      row?.copyright_lists?.map((row, indexCard) => {
        sumLiabilities += Number(row?.amount || 0);
      });

    /*---------- สิทธิบัตร ----------*/
    row?.options_property_intangible === "property_patent" &&
      row?.patent_lists
        ?.sort((a, b) => new Date(b?.created) - new Date(a?.created))
        ?.map((row, indexCard) => {
          sumLiabilities += Number(row?.amount || 0);
        });

    /*---------- อื่น ๆ ----------*/
    row?.options_property_intangible === "property_intangible_other" &&
      row?.intangible_other_lists
        ?.sort((a, b) => new Date(b?.created) - new Date(a?.created))
        ?.map((row, indexCard) => {
          sumLiabilities += Number(row?.amount || 0);
        });
  });
  return sumLiabilities;
};

export const sumDebtInvest = (balanceData) => {
  let sumDebtInvest = 0;

  let balanceLongDeptLength = balanceData?.debt_long_list
    ?.map(
      (item) =>
        item?.debt_long_others || item?.debt_long_places || item?.debt_long_cars
    )
    ?.flat()
    .filter((item) => item?.personal_or_investment === "investment")?.length;

  const carLists = () => {
    return balanceData?.debt_long_list
      ?.map((item) => item?.debt_long_cars)
      ?.flat()
      ?.filter((item) => item?.personal_or_investment === "investment");
  };

  const placeLists = () => {
    return balanceData?.debt_long_list
      ?.map((item) => item?.debt_long_places)
      ?.flat()
      ?.filter((item) => item?.personal_or_investment === "investment");
  };

  const otherLists = () => {
    return balanceData?.debt_long_list
      ?.map((item) => item?.debt_long_others)
      ?.flat()
      ?.filter((item) => item?.personal_or_investment === "investment");
  };

  if (balanceLongDeptLength > 0) {
    carLists()?.map((row, index) => {
      sumDebtInvest += Number(row?.current_price || 0);
    });

    placeLists()?.map((row, index) => {
      sumDebtInvest += Number(row?.current_price || 0);
    });

    otherLists()?.map((row, index) => {
      sumDebtInvest += Number(row?.current_price || 0);
    });
  }

  return sumDebtInvest;
};
